// React binding for the MainViewRegistry. Mirrors `usePanels` in ActivityBar:
// useSyncExternalStore over a cached, stable snapshot so re-renders only fire
// when the registry actually changes.

import { useSyncExternalStore } from 'react';
import { MainViewRegistry, type MainViewItem } from './MainViewRegistry';

export function useMainViews(): readonly MainViewItem[] {
  return useSyncExternalStore(
    MainViewRegistry.subscribe,
    MainViewRegistry.items,
    MainViewRegistry.items,
  );
}
